var map = {
	"./academy.svg": 340,
	"./achievements.svg": 341,
	"./add.svg": 342,
	"./added.svg": 343,
	"./albatros.svg": 344,
	"./arrow.svg": 345,
	"./arrow2.svg": 346,
	"./awards.svg": 347,
	"./birdie.svg": 348,
	"./check.svg": 349,
	"./city.svg": 350,
	"./close.svg": 351,
	"./club.svg": 352,
	"./country.svg": 353,
	"./course.svg": 354,
	"./courses.svg": 355,
	"./dashboard.svg": 356,
	"./eagle.svg": 357,
	"./facebook.svg": 358,
	"./female.svg": 359,
	"./friended.svg": 360,
	"./friends.svg": 361,
	"./game.svg": 362,
	"./golf.svg": 363,
	"./golfgo.svg": 364,
	"./handicap.svg": 365,
	"./heart.svg": 366,
	"./heart_full.svg": 367,
	"./hidden.svg": 368,
	"./hole-in-one.svg": 369,
	"./info.svg": 370,
	"./logo.svg": 371,
	"./male.svg": 372,
	"./menu.svg": 373,
	"./no-notifications.svg": 374,
	"./notifications.svg": 375,
	"./pending.svg": 376,
	"./progress.svg": 377,
	"./province.svg": 378,
	"./ranking-birdie.svg": 379,
	"./ranking-handicap.svg": 380,
	"./remove.svg": 381,
	"./scores.svg": 382,
	"./share.svg": 383,
	"./social_x.svg": 384,
	"./stern.svg": 385,
	"./suggestions.svg": 386,
	"./timeline.svg": 387,
	"./twitter.svg": 388,
	"./videos.svg": 389,
	"./visible.svg": 390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 339;